import { types } from '../actions/appNotifications';

const initialState = {
  message: null
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.SET_NOTIFICATION:
      return {
        ...state,
        message: action.payload
      };
    case types.REMOVE_NOTIFICATION:
      return {
        ...state,
        message: null
      };
    default:
      return state;
  }
}
